import { useGetUserQuery } from 'common'
import { useEventTypeContext } from 'features/event_type_provider'
import {
  isSurfaceEtPaymentsUpfrontEligible,
  SurfaceEtPaymentsUpfrontExperiment
} from 'features/growth_experiments'

import { useEventTypeEditorSidebar } from '../hooks'
import { EditForm } from './sections/edit_form'
import { NewForm } from './sections/new_form'
import { SectionDetail } from './sections/section_detail'

const FORCED_PAYMENTS_UPFRONT_VARIANT = 'variant_2'

const SectionPaneContent = ({ sectionKey, paymentsUpfrontVariant }) => {
  const { eventType, isCreation } = useEventTypeContext()
  const showPaymentsUpfront = Boolean(paymentsUpfrontVariant)

  if (sectionKey) {
    return (
      <SectionDetail
        sectionKey={sectionKey}
        eventType={eventType}
        showPaymentsUpfront={showPaymentsUpfront}
      />
    )
  }

  if (isCreation) {
    return (
      <NewForm
        showPaymentsUpfront={showPaymentsUpfront}
        paymentsUpfrontVariant={paymentsUpfrontVariant}
      />
    )
  }

  return (
    <EditForm
      showPaymentsUpfront={showPaymentsUpfront}
      paymentsUpfrontVariant={paymentsUpfrontVariant}
    />
  )
}

export const SectionPane = ({ sectionKey }) => {
  const { forcePaymentsUpfront } = useEventTypeEditorSidebar()
  const { data: userData } = useGetUserQuery()

  if (forcePaymentsUpfront) {
    return <SectionPaneContent sectionKey={sectionKey} paymentsUpfrontVariant={FORCED_PAYMENTS_UPFRONT_VARIANT} />
  }

  if (!isSurfaceEtPaymentsUpfrontEligible(userData?.user_feature_intent)) {
    return <SectionPaneContent sectionKey={sectionKey} paymentsUpfrontVariant={null} />
  }

  return (
    <SurfaceEtPaymentsUpfrontExperiment>
      {(paymentsUpfrontVariant) => (
        <SectionPaneContent
          sectionKey={sectionKey}
          paymentsUpfrontVariant={paymentsUpfrontVariant}
        />
      )}
    </SurfaceEtPaymentsUpfrontExperiment>
  )
}
